<template>
  <div data-v-9dfc9050="" data-v-2ac6a5fc="" class="login">
    <div data-v-9dfc9050="" class="login-header">
      <div data-v-9dfc9050="" class="close" @click="$router.go(-1)"></div>
      <a @click="$parent.goNav(`/register??pid=${pid}`)"
        ><div data-v-9dfc9050="" class="register-btn"><span data-v-9dfc9050="">注册</span></div></a
      >
    </div>
    <div data-v-9dfc9050="" class="login-content">
      <h1 data-v-9dfc9050="">登录</h1>
      <div data-v-9dfc9050="" class="login-form">
        <div data-v-9dfc9050="" class="login-group">
          <label data-v-9dfc9050="">手机号／用户名</label>
          <div data-v-9dfc9050="" class="login-input">
            <input data-v-9dfc9050="" v-model="loginInfo.name" id="loginName" autocomplete="off" maxlength="13" type="text" class="inpt username" />
            <div data-v-75833532="" data-v-9dfc9050="" class="count-down" style="display: none">
              <div data-v-75833532="" class="send">获取验证码</div>
            </div>
          </div>
        </div>
        <div data-v-9dfc9050="" class="login-group verifyWarp">
          <label data-v-9dfc9050=""> 密码 </label>
          <div data-v-9dfc9050="" class="login-input">
            <input data-v-9dfc9050="" v-model="loginInfo.password" autocomplete="off" maxlength="16" type="password" class="inpt" />
          </div>
        </div>
        <div data-v-9dfc9050="" class="login-group verifyWarp">
          <label data-v-9dfc9050=""> 验证码 </label>
          <div data-v-9dfc9050="" class="login-input" style="display: flex">
            <input data-v-9dfc9050="" v-model="loginInfo.code" autocomplete="off" maxlength="6" type="text" class="inpt" />
            <img style="cursor: pointer; height: 37px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </div>
        </div>
        <p data-v-9dfc9050="" class="forgetpassword">
          <a @click="$parent.openKefu()" style="color: #999"><span data-v-9dfc9050="">忘记账号／密码？</span></a>
        </p>
      </div>
      <div data-v-9dfc9050="" class="form-btn loginBtn" @click="login">登录</div>
      <p data-v-9dfc9050="" class="notes">{{$store.state.appInfo.title}}支持数字币存取 <span data-v-9dfc9050="">安全•便捷•秒到账</span></p>
    </div>

    <div data-v-15ef9544="" data-v-9dfc9050="" class="dialog"></div>
    <div data-v-15ef9544="" data-v-9dfc9050="" class="dialog"></div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return { loginInfo: {}, 
           imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
        index:0
        ,
      pid: '',

    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
              that.loginInfo.code = null;
        that.changIndex();
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
        }
      });
    },
    mounted() {
      let that = this;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/login.vue